import { Campaign } from 'ui/components';
import { useShouldShowContent } from 'helpers/audiencehelper';

export const CampaignFeature: React.FC<Umbraco.Campaign> = ({ content }) => {
	const show = useShouldShowContent(content.properties.audiencePicker);
	return show ? <Campaign {...content?.properties} /> : <></>;
};
